import PropTypes from 'prop-types';
import FileProp from './fileProp';
import JourneyProp from './journeyProp';
import UserProp from './userProp';

const propType = {
  owner: PropTypes.oneOfType([
    PropTypes.shape(UserProp.propType),
    PropTypes.string,
  ]).isRequired,
  journey: PropTypes.oneOfType([
    PropTypes.shape(JourneyProp.propType),
    PropTypes.string,
  ]).isRequired,
  documents: PropTypes.shape(FileProp.propType).isRequired,
};

export default { propType };
